import axios from 'axios'

export default {
  state: {
    brands: {
      updatedAt: null,
      data: [],
    },
  },
  actions: {
    async fetchBrands({ commit }) {
      const { data } = await axios.get(process.env.VUE_APP_BRANDS_URL)
      commit('SET_BRANDS', data)
    },
  },
  mutations: {
    SET_BRANDS(state, data) {
      state.brands = { updatedAt: Date(), data: data }
    },
  },
  getters: {
    brands(state) {
      return state.brands.data
    },
    brandNameByID: state => id => {
      return state.brands.data.find(brand => brand.slug === id).name
    },
  },
}
